module.exports = __webpack_public_path__ + "img/metropolitan_gen.cbb2cb4e.png";